import React from 'react';
import classnames from 'classnames';
import './style.styl';
import leftArrow from './img/left-arrow.png';
import rightArrow from './img/right-arrow.png';

class CarouselComponent extends React.Component {
    constructor(props) {
        super(props);
        this.testData = [
            {
                'text': 'pic1',
                'value': 'pic1'
            },
            {
                'text': 'pic2',
                'value': 'pic2'
            },
            {
                'text': 'pic3',
                'value': 'pic3'
            },
            {
                'text': 'pic4',
                'value': 'pic4'
            },
            {
                'text': 'pic5',
                'value': 'pic5'
            },
            {
                'text': 'pic6',
                'value': 'pic6'
            },
            {
                'text': 'pic7',
                'value': 'pic7'
            }
        ];
        this.config = {
            'singleWidth': 300,
            'defaultHeight': 670,
            'displaySize': 5
        };
        this.state = {
            'currentActiveIndex': props.currentActiveIndex || 2,
            'animationFlag': 0
        };
        this.colorArr = [
            'red',
            'blue',
            'yellow',
            'green',
            'grey',
            'brown',
            'pink'
        ];
    }

    generateCard = (data) => {
        const {
            currentActiveIndex
        } = this.state;
        const {
            animationFlag
        } = this.state;
        return data.map((item, index) => {
            const {
                isShow
            } = this.judgeWhetherDisplay(index);
            const positionIndex = (index - currentActiveIndex) * 60;
            let styleObj = {};
            if (positionIndex > 0) {
                styleObj['transform'] = `rotateY(69deg) scale(0.${10 - Math.abs(positionIndex / 60)})`;
                styleObj['transformOrigin'] = '100% 50% 0';
                styleObj['zIndex'] = 100 - (index - currentActiveIndex);
                styleObj['clipPath'] = 'polygon(0 8%, 0 92%, 100% 100%, 100% 0)';
                styleObj['left'] = `${positionIndex}px`
            } else if (positionIndex < 0) {
                styleObj['clipPath'] = 'polygon(0 0, 0 100%, 100% 92%, 100% 8%)';
                styleObj['transform'] = `rotateY(-69deg) scale(0.${10 - Math.abs(positionIndex / 60)})`;
                styleObj['transformOrigin'] = '0 50% 0';
                styleObj['left'] = `${positionIndex}px`;
                styleObj['zIndex'] = 100 - (currentActiveIndex - index);
            } else {
                styleObj['zIndex'] = 100;
                styleObj['left'] = 0;
            }
            styleObj = Object.assign(styleObj, {
                'boxShadow': '0 0 50px rgba(0,0,0,0.5)'
            });
            let flag = false;
            if (animationFlag === 1) {
                if (index === currentActiveIndex || index - currentActiveIndex === -1) {
                    flag = true;
                }
            }
            if (animationFlag === 2) {
                if (index === currentActiveIndex || currentActiveIndex - index === -1) {
                    flag = true;
                }
            }
            console.log(styleObj);
            return (
                <div className={'single-wrapper'} key={index}>
                    <div
                        key={index}
                        className={classnames(['single-carousel'], {
                            'single-hide': !isShow,
                            'animation-class': flag
                        })}
                        style={styleObj}
                    >
                        {item.content}
                    </div>
                </div>
            );
        })
    };

    judgeWhetherDisplay = (index) => {
        const { displaySize } = this.config;
        const {
            currentActiveIndex
        } = this.state;
        let isShow = false;
        const leftSize = Math.floor((displaySize - 1) / 2);
        const rightSize = displaySize - 1 - leftSize;
        if (index > currentActiveIndex) {
            isShow = (index - currentActiveIndex) <= rightSize;
        } else if (index < currentActiveIndex) {
            isShow = (currentActiveIndex - index) <= rightSize;
        } else {
            isShow = true;
        }
        return {
            isShow,
            leftSize,
            rightSize
        };
    };

    changeActive = (flag) => {
        const index = flag ? this.state.currentActiveIndex + 1 : this.state.currentActiveIndex - 1;
        this.setState({
            'currentActiveIndex': index,
            'animationFlag': flag ? 1 : 2
        });
        if (this.props.changeCardOne) {
            this.props.changeCardOne(index);
        }
        setTimeout(() => {
            this.setState({
                'animationFlag': 0
            })
        }, 1000);
    };

    changeToPage = (index) => {
        const {
            currentActiveIndex
        } = this.state;
        this.setState({
            'currentActiveIndex': index,
            'animationFlag': index > currentActiveIndex ? 1 : 2
        });
        setTimeout(() => {
            this.setState({
                'animationFlag': 0
            })
        }, 1000);
    };

    resetPage = () => {
        this.setState({
           'currentActiveIndex': 0
        });
    };

    render() {
        const {
            height, children
        } = this.props;
        const dataList = children || [];
        const {
            currentActiveIndex
        } = this.state;
        return (
            <div
                className={'carousel-wrapper'}
                style={{
                    'height': height || this.config.defaultHeight
                }}
            >
                <div className={'top-display'}>
                    {(dataList[currentActiveIndex] || {}).name || ''}
                </div>
                <div
                    className={'body-display'}
                >
                    <div className={'left-operation'}>
                        <img
                            className={classnames({
                                'operation-disable': currentActiveIndex === 0
                            })}
                            src={leftArrow}
                            alt="上一个"
                            title={'上一个'}
                            onClick={() => {
                                this.changeActive(false);
                            }}
                        />
                    </div>
                    <div className={'middle-content'}>
                        {this.generateCard(dataList)}
                    </div>
                    <div className={'right-operation'}>
                        <img
                            className={classnames({
                                'operation-disable': currentActiveIndex === dataList.length
                            })}
                            src={rightArrow}
                            alt="下一个"
                            title={'下一个'}
                            onClick={() => {
                                this.changeActive(true);
                            }}
                        />
                    </div>
                </div>
                <div className={'bottom-display'}>
                    <div className={'content'}>
                        {(dataList[currentActiveIndex] || {}).name || ''}
                        {(dataList[currentActiveIndex] || {}).description && <a download href={(dataList[currentActiveIndex] || {}).description}>[周报下载]</a>}
                    </div>
                </div>
            </div>
        );
    }
}

export default CarouselComponent;
